"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTransferLine = exports.CreateItinerary = void 0;
const models_1 = require("../../models");
const factories_1 = require("../../factories");
const getLegTransferAdjustments_1 = require("./getLegTransferAdjustments");
const dayjs = require("dayjs");
const uuid_1 = require("uuid");
const helpers_1 = require("../../helpers");
const _ = require("lodash");
const orders_1 = require("../orders");
const currencyFormatter_1 = require("../currencyFormatter");
const transfers_1 = require("../transfers");
const CreateItinerary = async ({ itinerary, order, variant_id, courses, supabase, }) => {
    let order_lines = [];
    // get the variant that has just been created
    const existing_variant = variant_id
        ? await factories_1.OrderRequestFactory.getVariantById(supabase, variant_id)
        : null;
    let addLegTransferAdjustments = null;
    if (existing_variant &&
        existing_variant?.config?.legs?.length > 0 &&
        itinerary?.transfers?.inter_region_transfer_type === "LAND") {
        addLegTransferAdjustments = await (0, getLegTransferAdjustments_1.getLegTransferAdjustments)(existing_variant);
        itinerary.transfers.leg_adjustments = addLegTransferAdjustments;
        if (addLegTransferAdjustments &&
            addLegTransferAdjustments.transfer_to_delete) {
            // delete the transfer line
            await supabase
                .from("order_lines")
                .delete()
                .eq("id", addLegTransferAdjustments.transfer_to_delete.id);
            if (addLegTransferAdjustments.from_area && itinerary.trip.type) {
                // i want to create the transfer line betwen the two legs
                const to_area = {
                    id: itinerary.trip.type != null &&
                        [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                        ? itinerary?.hotel?.where_when_who?.hotel?.id
                        : itinerary?.transfers?.primary_pickup_area?.id,
                    name: itinerary.trip.type &&
                        [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                        ? itinerary?.hotel?.where_when_who?.hotel?.name?.en
                        : itinerary?.transfers?.primary_pickup_area?.name?.en,
                    type: itinerary.trip.type &&
                        [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                        ? "Hotel"
                        : itinerary?.transfers?.primary_pickup_area?.type,
                    address: itinerary.trip.type &&
                        [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                        ? itinerary?.hotel?.where_when_who?.hotel?.name?.en
                        : itinerary?.transfers?.primary_pickup_area?.name?.en,
                };
                const transfer_line_config = await (0, exports.generateTransferLine)({
                    supabase,
                    date: itinerary?.trip?.start_date || "",
                    type: addLegTransferAdjustments.via_area ? "CUSTOM" : "ONE_WAY",
                    number_of_passengers: (itinerary?.trip?.number_of_golfers || 0) +
                        (itinerary?.trip?.number_of_non_golfers || 0) +
                        itinerary?.trip?.pga_pros?.count,
                    pickup_name: order.settings?.display_name?.first_name &&
                        order.settings?.display_name?.last_name
                        ? `${order.settings?.display_name?.first_name} ${order.settings?.display_name?.last_name}`
                        : `${order?.client?.first_name} ${order?.client?.last_name}`,
                    region_id: addLegTransferAdjustments.region_id || "",
                    to_area: to_area,
                    via_area: addLegTransferAdjustments.via_area
                        ? {
                            id: addLegTransferAdjustments.via_area.id,
                            name: addLegTransferAdjustments.via_area.name,
                            type: addLegTransferAdjustments.via_area.type,
                            address: addLegTransferAdjustments.via_area.name,
                        }
                        : null,
                    from_area: {
                        id: addLegTransferAdjustments.from_area.id,
                        name: addLegTransferAdjustments.from_area.name,
                        type: addLegTransferAdjustments.from_area.type,
                        address: addLegTransferAdjustments.from_area.name,
                    },
                    margin_discount_percentage: itinerary?.discounts?.margin_discount_percentages?.transfers || 0,
                    historic_pricing_adjustment: itinerary?.discounts?.historic_pricing_adjustment?.transfers || 5,
                });
                if (transfer_line_config) {
                    const golf_transfer_line = {
                        id: (0, uuid_1.v4)(),
                        order_id: order.id,
                        order_variant_id: variant_id,
                        type: "TRANSFER",
                    };
                    const golf_transfer_line_version = {
                        id: (0, uuid_1.v4)(),
                        order_line_id: golf_transfer_line.id,
                        config: transfer_line_config,
                        status: helpers_1.OrderLineStatus.DRAFT,
                        supplier_id: transfer_line_config?.supplier?.id.length > 0
                            ? transfer_line_config?.supplier?.id
                            : null,
                        region_id: itinerary?.trip?.region_id,
                        linked_line_id: addLegTransferAdjustments.hotel_order_line_id,
                        start_date: dayjs(itinerary?.trip?.start_date).format("YYYY-MM-DD"),
                        end_date: dayjs(itinerary?.trip?.start_date).format("YYYY-MM-DD"),
                        amount_paid: 0,
                        amount_refunded: 0,
                    };
                    golf_transfer_line.versions = [golf_transfer_line_version];
                    order_lines.push(golf_transfer_line);
                    // as we are creating the transfer line manually don't create the arrival airport order line
                    itinerary.transfers.arrival_airport_enabled = false;
                }
            }
        }
    }
    // return null
    // PROCESS GOLF ONLY
    if (itinerary?.trip?.type == models_1.TripType.GOLF) {
        // is there golf on the FIRST day of the trip?  i.e. if thre is an item at index 0 in the itinerary.courses.itinerary array
        const golf_order_lines = await createGolfOrderLines(itinerary, courses, variant_id, order, itinerary?.transfers?.primary_pickup_area || null, supabase);
        const airport_order_lines = itinerary?.transfers?.type === models_1.TransferType.AIRPORT ||
            itinerary?.transfers?.type === models_1.TransferType.GOLF_AIRPORT
            ? await createAirportTransferOrderLines(supabase, itinerary, variant_id, null, order)
            : [];
        order_lines = [...order_lines, ...golf_order_lines, ...airport_order_lines];
    }
    else {
        // PROCESS GOLF HOTEL
        const hotel_order_line_id = (0, uuid_1.v4)();
        const hotel_order_line = {
            id: hotel_order_line_id,
            order_id: order.id,
            order_variant_id: variant_id,
            type: "HOTEL",
        };
        let hotel_order_line_config = _.cloneDeep(helpers_1.HOTEL_ORDER_LINE_STATE);
        // merge the hotel config
        hotel_order_line_config = {
            ...hotel_order_line_config,
            ...itinerary?.hotel,
        };
        const hotel_order_line_version = {
            id: (0, uuid_1.v4)(),
            order_line_id: hotel_order_line.id,
            config: hotel_order_line_config,
            status: helpers_1.OrderLineStatus.DRAFT,
            supplier_id: hotel_order_line_config?.supplier?.id,
            region_id: hotel_order_line_config?.where_when_who?.region_id,
            start_date: dayjs(itinerary?.trip?.start_date).format("YYYY-MM-DD"),
            end_date: dayjs(itinerary?.trip?.start_date)
                .add(itinerary?.trip?.duration_days_nights || 0, "day")
                .format("YYYY-MM-DD"),
            amount_paid: 0,
            amount_refunded: 0,
        };
        hotel_order_line.versions = [hotel_order_line_version];
        order_lines.push(hotel_order_line);
        const airport_order_lines = itinerary?.transfers?.type === models_1.TransferType.AIRPORT ||
            itinerary?.transfers?.type === models_1.TransferType.GOLF_AIRPORT
            ? await createAirportTransferOrderLines(supabase, itinerary, variant_id, hotel_order_line, order)
            : [];
        const golf_order_lines = await createGolfOrderLines(itinerary, courses, variant_id, order, {
            id: hotel_order_line_config?.where_when_who?.hotel?.id,
            name: hotel_order_line_config?.where_when_who?.hotel?.name,
            type: "Hotel",
        }, supabase);
        order_lines = [...order_lines, ...golf_order_lines, ...airport_order_lines];
    }
    // async for each order_line
    const { data: { user }, } = await supabase.auth.getUser();
    const order_lines_to_create = order_lines.map((order_line) => {
        const line = _.cloneDeep(order_line);
        delete line.versions;
        return line;
    });
    const version_lines_to_create = order_lines.map((order_line) => {
        const line = _.cloneDeep(order_line);
        if (!line.versions)
            return null;
        const version = line.versions[0];
        version.created_by = user?.id;
        delete version.id;
        return version;
    });
    await supabase.from("order_lines").insert(order_lines_to_create);
    await supabase.from("order_line_versions").insert(version_lines_to_create);
    await (0, orders_1.addOrderLog)(supabase, {
        type: "ORDER",
        order_id: order.id,
        detail: {
            type: "Order Leg Created",
            status: order.status,
            title: `${order.reference}`,
            message: ``,
        },
    });
    for (let i = 0; i < order_lines.length; i++) {
        const desc = (0, orders_1.getOrderLineDescriptions)(order_lines[i]);
        const latest_version = order_lines[i].versions?.[0];
        await (0, orders_1.addOrderLog)(supabase, {
            type: order_lines[i].type,
            order_id: order_lines[i].order_id,
            detail: {
                type: "Line Created",
                status: latest_version?.status,
                title: `${(0, orders_1.getOrderLineTitle)(order_lines[i])} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`,
                total: (0, currencyFormatter_1.currencyFormatter)((0, orders_1.getOrderLineCurrency)(order_lines[i]) || "", (0, orders_1.getOrderLineTotal)(order_lines[i]), false),
                message: `${desc && desc.join("<br/>")}`,
            },
        });
    }
    // update the order variant to set the country_id
    await supabase
        .from("order_variants")
        .update({
        country_id: itinerary?.trip?.country_id,
    })
        .eq("id", variant_id);
    return true;
};
exports.CreateItinerary = CreateItinerary;
const isGolfFreeTransfer = async (supabase, golf, itinerary) => {
    if (!golf)
        return false;
    if (itinerary?.transfers?.type === models_1.TransferType.GOLF_AIRPORT ||
        itinerary?.transfers?.type === models_1.TransferType.GOLF) {
        const from_area = {
            id: itinerary.trip.type != null &&
                [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                ? itinerary?.hotel?.where_when_who?.hotel?.id
                : itinerary?.transfers?.primary_pickup_area?.id,
            name: itinerary.trip.type != null &&
                [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                ? itinerary?.hotel?.where_when_who?.hotel?.name?.en
                : itinerary?.transfers?.primary_pickup_area?.name?.en,
            type: itinerary.trip.type != null &&
                [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                ? "Hotel"
                : itinerary?.transfers?.primary_pickup_area?.type,
            address: itinerary.trip.type != null &&
                [models_1.TripType.GOLF_HOTEL, models_1.TripType.PGA].includes(itinerary.trip.type)
                ? itinerary?.hotel?.where_when_who?.hotel?.name?.en
                : itinerary?.transfers?.primary_pickup_area?.name?.en,
        };
        return await hasFreeTransferToCourse(supabase, from_area, // FROM
        {
            id: golf.config.course.id,
            name: golf?.config?.course?.name?.en,
            type: "Course",
            address: golf?.config?.course?.name?.en,
        }, // TO
        itinerary?.trip?.start_date || "", (itinerary?.trip?.number_of_golfers || 0) +
            itinerary?.trip?.pga_pros?.count);
    }
    return false;
};
const hasFreeTransferToCourse = async (supabase, from_area, to_area, date, passengers) => {
    const rates = await (0, transfers_1.getBestTransferRate)(supabase, null, from_area, to_area, null, "RETURN", date, passengers, 0, 0);
    return rates?.vehicle?.total === 0;
};
const isFirstDayGolf = (rate, itinerary) => {
    return rate.config?.where_when_who?.date === itinerary?.trip?.start_date;
};
const isLastDayGolf = (rate, itinerary) => {
    return (rate.config?.where_when_who.date ===
        dayjs(itinerary?.trip?.start_date)
            .add(itinerary?.trip?.duration_days_nights || 0, "day")
            .format("YYYY-MM-DD"));
};
const getFirstDayGolf = (itinerary) => {
    return itinerary?.courses?.itinerary.find((c) => c?.config && c.config?.where_when_who.date === itinerary?.trip?.start_date);
};
const getLastDayGolf = (itinerary) => {
    return itinerary?.courses?.itinerary.find((c) => c?.config &&
        c.config?.where_when_who.date ===
            dayjs(itinerary?.trip?.start_date)
                .add(itinerary?.trip?.duration_days_nights || 0, "day")
                .format("YYYY-MM-DD"));
};
const createCustomGolfTransferLine = async (supabase, is_first_day_golf, is_last_day_golf, itinerary, transfer_origin, order) => {
    // if first day golf then its AIRPORT > COURSE > HOTEL
    if (is_first_day_golf) {
        const first_day_golf = getFirstDayGolf(itinerary);
        return await (0, exports.generateTransferLine)({
            supabase,
            date: first_day_golf?.config?.where_when_who?.date || "",
            type: "CUSTOM",
            number_of_passengers: (itinerary?.trip?.number_of_golfers || 0) +
                (itinerary?.trip?.number_of_non_golfers || 0) +
                itinerary?.trip?.pga_pros?.count,
            pickup_name: order.settings?.display_name?.first_name &&
                order.settings?.display_name?.last_name
                ? `${order.settings?.display_name?.first_name} ${order.settings?.display_name?.last_name}`
                : `${order?.client?.first_name} ${order?.client?.last_name}`,
            region_id: first_day_golf?.config?.where_when_who?.region_id || "",
            to_area: {
                id: transfer_origin.id,
                name: transfer_origin.name?.en,
                type: transfer_origin.type,
                address: transfer_origin.name?.en,
            },
            via_area: {
                id: first_day_golf?.config?.course?.id,
                name: first_day_golf?.config?.course?.name?.en,
                type: "Course",
                address: first_day_golf?.config?.course?.name?.en,
            },
            from_area: {
                id: itinerary?.transfers?.arrival_airport?.id,
                name: itinerary?.transfers?.arrival_airport?.name?.en,
                type: itinerary?.transfers?.arrival_airport?.type,
                address: "",
            },
            margin_discount_percentage: itinerary?.discounts?.margin_discount_percentages?.transfers || 0,
            historic_pricing_adjustment: itinerary?.discounts?.historic_pricing_adjustment?.transfers || 5,
        });
    }
    // if last day golf then its HOTEL > COURSE > AIRPORT
    if (is_last_day_golf) {
        const last_day_golf = getLastDayGolf(itinerary);
        return await (0, exports.generateTransferLine)({
            supabase,
            date: last_day_golf?.config?.where_when_who?.date || "",
            type: "CUSTOM",
            number_of_passengers: (itinerary?.trip?.number_of_golfers || 0) +
                (itinerary?.trip?.number_of_non_golfers || 0) +
                itinerary?.trip?.pga_pros?.count,
            pickup_name: order.settings?.display_name?.first_name &&
                order.settings?.display_name?.last_name
                ? `${order.settings?.display_name?.first_name} ${order.settings?.display_name?.last_name}`
                : `${order?.client?.first_name} ${order?.client?.last_name}`,
            region_id: last_day_golf?.config?.where_when_who?.region_id || "",
            from_area: {
                id: transfer_origin.id,
                name: transfer_origin.name?.en,
                type: transfer_origin.type,
                address: transfer_origin.name?.en,
            },
            via_area: {
                id: last_day_golf?.config?.course?.id,
                name: last_day_golf?.config?.course?.name?.en,
                type: "Course",
                address: last_day_golf?.config?.course?.name?.en,
            },
            to_area: (itinerary?.transfers?.return_to_origin_airport
                ? {
                    id: itinerary?.transfers?.arrival_airport?.id,
                    name: itinerary?.transfers?.arrival_airport?.name?.en,
                    type: itinerary?.transfers?.arrival_airport?.type,
                    address: "",
                }
                : {
                    id: itinerary?.transfers?.departure_airport?.id,
                    name: itinerary?.transfers?.departure_airport?.name?.en,
                    type: itinerary?.transfers?.departure_airport?.type,
                    address: "",
                }),
            margin_discount_percentage: itinerary?.discounts?.margin_discount_percentages?.transfers || 0,
            historic_pricing_adjustment: itinerary?.discounts?.historic_pricing_adjustment?.transfers || 5,
        });
    }
    return null;
};
const createAirportTransferOrderLines = async (supabase, itinerary, variant_id, hotel_order_line, order) => {
    const order_lines = [];
    const first_day_golf = getFirstDayGolf(itinerary);
    const last_day_golf = getLastDayGolf(itinerary);
    const first_day_free_transfer = await isGolfFreeTransfer(supabase, first_day_golf, itinerary);
    const last_day_free_transfer = await isGolfFreeTransfer(supabase, last_day_golf, itinerary);
    // if there is a golf line on the first day
    const hotel_config = hotel_order_line && hotel_order_line.versions
        ? hotel_order_line.versions[0].config
        : null;
    // THIS IS CREATING THE TRANSFER FROM THE AIRPORT TO THE HOTEL
    /* LOGIC -
      - If no golf on the first day or there is golf on the first day but there is a free transfer then we create a standard transfer
      OR
      - If there is golf on the first day with AIRPORT ONLY transfers and the transfer type is STANDARD then we create a standard transfer
    */
    if (((first_day_golf && first_day_free_transfer) ||
        !first_day_golf ||
        (first_day_golf &&
            itinerary.transfers?.arrival_transfer_type === "STANDARD")) &&
        itinerary?.transfers?.arrival_airport_enabled) {
        // INBOUND AIRPORT TRANSFER
        const inbound_transfer_line = {
            id: (0, uuid_1.v4)(),
            order_id: order.id,
            order_variant_id: variant_id,
            type: "TRANSFER",
        };
        const inbound_date = itinerary.trip.type == models_1.TripType.GOLF
            ? itinerary.trip.start_date
            : hotel_config?.where_when_who?.check_in_date;
        const inbound_passengers = itinerary.trip.type == models_1.TripType.GOLF
            ? (itinerary.trip.number_of_golfers || 0) +
                (itinerary.trip.number_of_non_golfers || 0) +
                itinerary?.trip?.pga_pros?.count
            : hotel_config?.where_when_who?.number_of_guests;
        const inbound_region = itinerary.trip.type == models_1.TripType.GOLF
            ? itinerary.trip.region_id
            : hotel_config?.where_when_who?.region_id;
        const inbound_destination_area = itinerary?.trip.type == models_1.TripType.GOLF
            ? {
                id: itinerary?.transfers?.primary_pickup_area?.id,
                name: itinerary?.transfers?.primary_pickup_area?.name?.en,
                type: itinerary?.transfers?.primary_pickup_area?.type,
                address: "",
            }
            : {
                id: hotel_config?.where_when_who?.hotel?.id,
                name: hotel_config?.where_when_who?.hotel?.name?.en,
                type: "Hotel",
                address: hotel_config?.where_when_who?.hotel?.name?.en,
            };
        let inbound_transfer_line_config = null;
        inbound_transfer_line_config = await (0, exports.generateTransferLine)({
            supabase,
            date: inbound_date || "",
            type: "ONE_WAY",
            number_of_passengers: inbound_passengers || 0,
            pickup_name: order.settings?.display_name?.first_name &&
                order.settings?.display_name?.last_name
                ? `${order.settings?.display_name?.first_name} ${order.settings?.display_name?.last_name}`
                : `${order?.client?.first_name} ${order?.client?.last_name}`,
            region_id: inbound_region || "",
            to_area: inbound_destination_area,
            from_area: {
                id: itinerary?.transfers?.arrival_airport?.id,
                name: itinerary?.transfers?.arrival_airport?.name?.en,
                type: itinerary?.transfers?.arrival_airport?.type,
                address: "",
            },
            margin_discount_percentage: itinerary?.discounts?.margin_discount_percentages?.transfers || 0,
            historic_pricing_adjustment: itinerary?.discounts?.historic_pricing_adjustment?.transfers || 5,
        });
        // }
        const inbound_transfer_line_version = {
            id: (0, uuid_1.v4)(),
            order_line_id: inbound_transfer_line.id,
            config: inbound_transfer_line_config,
            status: helpers_1.OrderLineStatus.DRAFT,
            supplier_id: inbound_transfer_line_config?.supplier?.id || undefined,
            region_id: inbound_region,
            linked_line_id: hotel_order_line?.id,
            start_date: dayjs(inbound_date).format("YYYY-MM-DD"),
            end_date: dayjs(inbound_date).format("YYYY-MM-DD"),
            amount_paid: 0,
            amount_refunded: 0,
        };
        inbound_transfer_line.versions = [inbound_transfer_line_version];
        order_lines.push(inbound_transfer_line);
    }
    // THIS IS CREATING THE TRANSFER FROM THE HOTEL TO THE AIRPORT
    if (((last_day_golf && last_day_free_transfer) ||
        !last_day_golf ||
        (last_day_golf &&
            itinerary.transfers?.departure_transfer_type === "STANDARD")) &&
        itinerary?.transfers?.departure_airport_enabled) {
        // OUTBOUND AIRPORT TRANSFER
        const outbound_transfer_line = {
            id: (0, uuid_1.v4)(),
            order_id: order.id,
            order_variant_id: variant_id,
            type: "TRANSFER",
        };
        const outbound_date = itinerary.trip.type == models_1.TripType.GOLF
            ? dayjs(itinerary.trip.start_date)
                .add(itinerary.trip.duration_days_nights || 0, "day")
                .format("YYYY-MM-DD")
            : dayjs(hotel_config?.where_when_who.check_in_date)
                .add(hotel_config?.where_when_who.number_of_nights || 0, "day")
                .format("YYYY-MM-DD");
        const outbound_passengers = itinerary.trip.type == models_1.TripType.GOLF
            ? (itinerary.trip.number_of_golfers || 0) +
                (itinerary.trip.number_of_non_golfers || 0) +
                itinerary?.trip?.pga_pros?.count
            : hotel_config?.where_when_who?.number_of_guests;
        const outbound_region = itinerary.trip.type == models_1.TripType.GOLF
            ? itinerary.trip.region_id
            : hotel_config?.where_when_who?.region_id;
        const outbound_origin_area = itinerary?.trip.type == models_1.TripType.GOLF
            ? {
                id: itinerary?.transfers?.primary_pickup_area?.id,
                name: itinerary?.transfers?.primary_pickup_area?.name?.en,
                type: itinerary?.transfers?.primary_pickup_area?.type,
                address: "",
            }
            : {
                id: hotel_config?.where_when_who?.hotel?.id,
                name: hotel_config?.where_when_who?.hotel?.name?.en,
                type: "Hotel",
                address: hotel_config?.where_when_who?.hotel?.name?.en,
            };
        let outbound_transfer_line_config = null;
        outbound_transfer_line_config = await (0, exports.generateTransferLine)({
            supabase,
            date: outbound_date,
            type: "ONE_WAY",
            number_of_passengers: outbound_passengers || 0,
            pickup_name: order.settings?.display_name?.first_name &&
                order.settings?.display_name?.last_name
                ? `${order.settings?.display_name?.first_name} ${order.settings?.display_name?.last_name}`
                : `${order?.client?.first_name} ${order?.client?.last_name}`,
            region_id: outbound_region || "",
            from_area: outbound_origin_area,
            to_area: (itinerary?.transfers?.return_to_origin_airport
                ? {
                    id: itinerary?.transfers?.arrival_airport?.id,
                    name: itinerary?.transfers?.arrival_airport?.name?.en,
                    type: itinerary?.transfers?.arrival_airport?.type,
                    address: "",
                }
                : {
                    id: itinerary?.transfers?.departure_airport?.id,
                    name: itinerary?.transfers?.departure_airport?.name?.en,
                    type: itinerary?.transfers?.departure_airport?.type,
                    address: "",
                }),
            margin_discount_percentage: itinerary?.discounts?.margin_discount_percentages?.transfers || 0,
            historic_pricing_adjustment: itinerary?.discounts?.historic_pricing_adjustment?.transfers || 5,
        });
        const outbound_transfer_line_version = {
            id: (0, uuid_1.v4)(),
            order_line_id: outbound_transfer_line.id,
            config: outbound_transfer_line_config,
            status: helpers_1.OrderLineStatus.DRAFT,
            supplier_id: outbound_transfer_line_config?.supplier?.id || undefined,
            region_id: outbound_region,
            linked_line_id: hotel_order_line?.id,
            start_date: dayjs(outbound_date).format("YYYY-MM-DD"),
            end_date: dayjs(outbound_date).format("YYYY-MM-DD"),
            amount_paid: 0,
            amount_refunded: 0,
        };
        outbound_transfer_line.versions = [outbound_transfer_line_version];
        order_lines.push(outbound_transfer_line);
    }
    return order_lines;
};
const createGolfOrderLines = async (itinerary, courses, variant_id, order, transfer_origin, supabase) => {
    const order_lines = [];
    const filtered_courses = itinerary?.courses?.itinerary.filter((course) => course !== null && course !== undefined);
    for (let i = 0; i < filtered_courses.length; i++) {
        const rate = filtered_courses[i];
        const course = courses.find((c) => c.id === rate.config?.course?.id);
        const is_first_day_golf = isFirstDayGolf(rate, itinerary);
        const is_last_day_golf = isLastDayGolf(rate, itinerary);
        const is_first_day_free_transfer = is_first_day_golf
            ? await isGolfFreeTransfer(supabase, rate, itinerary)
            : false;
        const is_last_day_free_transfer = is_last_day_golf
            ? await isGolfFreeTransfer(supabase, rate, itinerary)
            : false;
        const golf_order_line = {
            id: (0, uuid_1.v4)(),
            order_id: order.id,
            type: "GOLF",
            order_variant_id: variant_id,
        };
        let golf_line_config = rate.config;
        golf_line_config = {
            ...golf_line_config,
            course: {
                ...golf_line_config.course,
                closures: [],
                public_holidays: [],
                warnings: [],
            },
        };
        const golf_order_line_version = {
            id: (0, uuid_1.v4)(),
            order_line_id: golf_order_line.id,
            config: golf_line_config,
            status: helpers_1.OrderLineStatus.DRAFT,
            supplier_id: golf_line_config?.supplier?.id,
            region_id: golf_line_config?.where_when_who?.region_id,
            start_date: dayjs(golf_line_config?.where_when_who.date).format("YYYY-MM-DD"),
            end_date: dayjs(golf_line_config?.where_when_who.date).format("YYYY-MM-DD"),
            amount_paid: 0,
            amount_refunded: 0,
        };
        golf_order_line.versions = [golf_order_line_version];
        order_lines.push(golf_order_line);
        // do transfers if required
        // If there is golf on the first/last day of the trip then we need to create a CUSTOM transfer line unless there is a free transfer.  This will be assigned to the golf line
        if (itinerary?.transfers?.type === models_1.TransferType.AIRPORT ||
            itinerary?.transfers?.type === models_1.TransferType.GOLF_AIRPORT ||
            itinerary?.transfers?.type === models_1.TransferType.GOLF) {
            let transfer_line_config = null;
            // only create the custom transfer if there is a requested AIRPORT transfer
            if (((is_first_day_golf &&
                !is_first_day_free_transfer &&
                itinerary?.transfers?.arrival_transfer_type === "CUSTOM" &&
                itinerary.transfers.arrival_airport_enabled) ||
                (is_last_day_golf &&
                    !is_last_day_free_transfer &&
                    itinerary?.transfers?.departure_transfer_type === "CUSTOM" &&
                    itinerary.transfers.departure_airport_enabled)) &&
                (itinerary?.transfers?.type === models_1.TransferType.AIRPORT ||
                    itinerary?.transfers?.type === models_1.TransferType.GOLF_AIRPORT)) {
                transfer_line_config = transfer_origin
                    ? await createCustomGolfTransferLine(supabase, is_first_day_golf, is_last_day_golf, itinerary, transfer_origin, order)
                    : null;
            }
            else if (itinerary?.transfers?.type === models_1.TransferType.GOLF_AIRPORT ||
                itinerary?.transfers?.type === models_1.TransferType.GOLF) {
                transfer_line_config = await (0, exports.generateTransferLine)({
                    supabase,
                    date: golf_line_config?.where_when_who?.date,
                    type: "RETURN",
                    number_of_passengers: golf_line_config?.where_when_who?.number_of_golfers,
                    pickup_name: order.settings?.display_name?.first_name &&
                        order.settings?.display_name?.last_name
                        ? `${order.settings?.display_name?.first_name} ${order.settings?.display_name?.last_name}`
                        : `${order?.client?.first_name} ${order?.client?.last_name}`,
                    region_id: course?.region?.id || "",
                    to_area: {
                        id: course?.id,
                        name: course?.name?.en,
                        type: "Course",
                        address: course?.name?.en,
                    },
                    from_area: {
                        id: transfer_origin?.id,
                        name: transfer_origin?.name?.en,
                        type: transfer_origin?.type,
                        address: "",
                    },
                    margin_discount_percentage: itinerary?.discounts?.margin_discount_percentages?.transfers || 0,
                    historic_pricing_adjustment: itinerary?.discounts?.historic_pricing_adjustment?.transfers || 5,
                });
            }
            // If there is config add the line
            if (transfer_line_config) {
                const golf_transfer_line = {
                    id: (0, uuid_1.v4)(),
                    order_id: order.id,
                    order_variant_id: variant_id,
                    type: "TRANSFER",
                };
                const golf_transfer_line_version = {
                    id: (0, uuid_1.v4)(),
                    order_line_id: golf_transfer_line.id,
                    config: transfer_line_config,
                    status: helpers_1.OrderLineStatus.DRAFT,
                    supplier_id: transfer_line_config?.supplier?.id.length > 0
                        ? transfer_line_config?.supplier?.id
                        : null,
                    region_id: itinerary?.trip?.region_id,
                    linked_line_id: golf_order_line.id,
                    start_date: dayjs(golf_line_config?.where_when_who.date).format("YYYY-MM-DD"),
                    end_date: dayjs(golf_line_config?.where_when_who.date).format("YYYY-MM-DD"),
                    amount_paid: 0,
                    amount_refunded: 0,
                };
                golf_transfer_line.versions = [golf_transfer_line_version];
                order_lines.push(golf_transfer_line);
            }
        }
    }
    return order_lines;
};
const generateTransferLine = async ({ supabase, date, type, pickup_name, number_of_passengers, region_id, from_area, to_area, via_area, margin_discount_percentage = 0, historic_pricing_adjustment = 5, }) => {
    let transfer_line_config = _.cloneDeep(helpers_1.TRANSFER_LINE_INITIAL_STATE);
    transfer_line_config.where_when_who.date = dayjs(date).format("YYYY-MM-DD");
    transfer_line_config.where_when_who.type = type;
    transfer_line_config.where_when_who.number_of_passengers =
        number_of_passengers;
    transfer_line_config.where_when_who.region_id = region_id;
    transfer_line_config.where_when_who.pickup_name = pickup_name;
    // OUTBOUND
    transfer_line_config.transfer_legs.outbound = {
        from_area: from_area?.id,
        from_name: from_area?.name,
        from_type: from_area?.type,
        to_area: via_area ? via_area.id : to_area.id,
        to_name: via_area ? via_area.name : to_area.name,
        to_type: via_area ? via_area.type : to_area.type,
        to_details: {
            requested_arrival_time: 30,
        },
        from_details: {
            address: from_area?.address,
        },
    };
    // INBOUND
    if (type !== "ONE_WAY") {
        transfer_line_config.transfer_legs.inbound = {
            to_area: via_area ? to_area?.id : from_area?.id,
            to_name: via_area ? to_area?.name : from_area?.name,
            to_type: via_area ? to_area?.type : from_area.type,
            from_area: via_area ? via_area.id : to_area.id,
            from_name: via_area ? via_area.name : to_area.name,
            from_type: via_area ? via_area.type : to_area.type,
            to_details: {
                address: via_area ? via_area.address : to_area.address,
            },
            from_details: {
                requested_arrival_time: 30,
            },
        };
    }
    transfer_line_config = await (0, transfers_1.searchTransferRatesIncludingHistorical)(supabase, null, transfer_line_config, from_area, to_area, via_area ? via_area : null, type, date, number_of_passengers, margin_discount_percentage, historic_pricing_adjustment);
    return transfer_line_config;
};
exports.generateTransferLine = generateTransferLine;
